import { useEffect } from 'react';
import {
  EMPLOYER_FOOTPRINT_TOUR_TARGET,
  checkpointTourTarget,
} from '../../../lib/employerReview/checkpointTourCopy';
import { isStreetViewTourStep } from '../../../lib/employerReview/buildFindingEvidenceTourSteps';
import { scrollBehaviorReducedAware } from '../../../lib/prefersReducedMotion';
import { useEmployerEvidenceTourOptional } from './EmployerEvidenceTourContext';

function scrollToTourTarget(target: string) {
  document
    .querySelector<HTMLElement>(`[data-tour-target="${target}"]`)
    ?.scrollIntoView({ behavior: scrollBehaviorReducedAware(), block: 'center', inline: 'nearest' });
}

/** Scroll + panel state for checkpoint and street-view guided steps. */
export function EvidenceGuideController() {
  const tour = useEmployerEvidenceTourOptional();

  useEffect(() => {
    if (!tour?.activeTour) return;
    const step = tour.activeTour.steps[tour.activeTour.stepIndex];
    if (!step) return;

    if (isStreetViewTourStep(step)) {
      tour.setGateAnalysisOpen(false);
      tour.setCheckpointDetailsOpen(false);
      scrollToTourTarget(EMPLOYER_FOOTPRINT_TOUR_TARGET);
      window.setTimeout(() => scrollToTourTarget(step.target), 400);
      return;
    }

    if (step.checkpointId) {
      tour.setGateAnalysisOpen(true);
      tour.setCheckpointDetailsOpen(true);
      const [gate, checkpointStep] = step.checkpointId.split(':');
      if (gate && checkpointStep) {
        window.setTimeout(
          () => scrollToTourTarget(checkpointTourTarget(gate, checkpointStep)),
          280,
        );
      }
    }
  }, [tour?.activeTour?.stepIndex, tour?.activeTour]);

  useEffect(() => {
    if (!tour?.activeTour) return;
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        tour.closeTour();
        return;
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        if (tour.activeTour!.stepIndex >= tour.activeTour!.steps.length - 1) {
          tour.closeTour();
        } else {
          tour.nextStep();
        }
      }
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        tour.prevStep();
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [tour]);

  return null;
}
